function CommandModalController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.triggers = ctrl.resolve.triggers;
    ctrl.conditions = ctrl.resolve.conditions;
    ctrl.condition = ctrl.resolve.condition;
    ctrl.variables = ctrl.resolve.variables;
    ctrl.environmentVariableObjects = ctrl.resolve.environmentVariableObjects;
    ctrl.command = {};
    if (ctrl.condition.condition) {
      ctrl.command.wait_condition = ctrl.condition.condition;
    } else if (ctrl.condition.statement) {
      ctrl.command.wait_condition = ctrl.condition.statement;
    }
    ctrl.selections = [];
    ctrl.specialTriggers = [
      { id: 1, name: 'Skip: Stream Collection', code: 'skip_trigger_id' },
      { id: 2, name: 'Disable: Stream Collection', code: 'disable_trigger_id' },
      { id: 3, name: 'Skip: Condition', code: 'skip_condition_id' },
      { id: 4, name: 'Disable: Condition', code: 'disable_condition_id' },
      { id: 5, name: 'Initialize: Condition', code: 'initialize_condition_id' },
      { id: 6, name: 'Set variable', code: 'set' },
      { id: 7, name: 'Wait', code: 'wait_condition' },
    ];
    ctrl.types = [
      { type: 'Environment variable', id: 0 },
    ];
  };

  ctrl.setEnvVarDefaultValue = () => {
    let variableObject = ctrl.environmentVariableObjects.find(({ name }) => name === ctrl.setObject.var);
    if (variableObject) {
      ctrl.setObject.value = variableObject.default_value;
    }
  }

  const compileSetVariable = () => {
    if (ctrl.setObject.type === 0) { // ENVIRONMENT VARIABLE
      ctrl.command.set = `#${ctrl.setObject.var} := ${ctrl.setObject.value}`;
    }
  };

  ctrl.submit = () => {
    if (ctrl.command.type === 'skip_trigger_id') {
      if (ctrl.command.target_all) {
        ctrl.command.type = 'skip_trigger_all';
        ctrl.command.skip_trigger_all = true;
      } else {
        ctrl.command.skip_trigger_id = ctrl.command.target_id;
      }
    }
    else if (ctrl.command.type === 'disable_trigger_id') {
      if (ctrl.command.target_all) {
        ctrl.command.type = 'disable_trigger_all';
        ctrl.command.disable_trigger_all = true;
      } else {
        ctrl.command.skip_trigger_id = ctrl.command.target_id;
      }
    }
    else if (ctrl.command.type === 'skip_condition_id') {
      ctrl.command.skip_condition_id = ctrl.command.target_id;
    }
    else if (ctrl.command.type === 'disable_condition_id') {
      ctrl.command.disable_condition_id = ctrl.command.target_id;
    }
    else if (ctrl.command.type === 'initialize_condition_id') {
      if (ctrl.command.target_all) {
        ctrl.command.type = 'initialize_condition_all';
        ctrl.command.initialize_condition_all = true;
      } else {
        ctrl.command.initialize_condition_id = ctrl.command.target_id;
      }
    }
    else if (ctrl.command.type === 'set') {
      compileSetVariable();
    }
    ctrl.close({ $value: ctrl.command });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('CommandModalController', CommandModalController);
